// Azure App Registration Client ID for NAA (Nested App Authentication) - PROD
// Get this from your Azure portal app registration
// See: https://learn.microsoft.com/en-us/office/dev/add-ins/develop/enable-nested-app-authentication-in-your-add-in
export const AZURE_CLIENT_ID = "67a7b02d-8194-4323-a6ce-5edc1ea12606";

// FastAPI Backend Base URL - PROD (Railway)
// Injected at build time by webpack DefinePlugin when building (e.g. on Railway). Default: Railway backend URL.
// In Railway dashboard, set API_BASE_URL to override (e.g. https://my-ai-secretary-fastapi-production.up.railway.app/api/v1).
export const API_BASE_URL =
  process.env.API_BASE_URL ?? "https://my-ai-secretary-fastapi-production.up.railway.app/api/v1";

